import React from "react";
import Navibar from "./Navibar";
import LeftNavigation from "./LeftNavigation";
import { useAgency } from "@/contexts/AgencyContext";
import { NotificationsProvider } from "@/contexts/NotificationsContext";
import { usePageTitle } from "@/hooks/usePageTitle";

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
  isLeftNavCollapsed: boolean;
  toggleLeftNav: () => void;
  pageTitle?: string;
}

export const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children,
  isLeftNavCollapsed,
  toggleLeftNav,
  pageTitle,
}: AuthenticatedLayoutProps) => {
  const { agency } = useAgency();

  usePageTitle({
    agencyName: agency?.company_name,
    pageTitle
  });

  return (
    <NotificationsProvider>
      <div className="w-full h-dvh flex flex-col bg-background">
        <Navibar />
        <div className="w-full flex relative flex-1 min-h-0">
          <div
            className={`transition-all sm:block hidden duration-300 ease-in-out ${
              isLeftNavCollapsed ? "w-[75px]" : "w-[260px]"
            }`}
          >
            <LeftNavigation isCollapsed={isLeftNavCollapsed} onToggle={toggleLeftNav} />
          </div>
          <div className="flex-1 w-full max-w-[1500px] mx-auto z-20 h-full min-h-0 md:px-6 px-4 overflow-auto py-6 transition-all duration-300 ease-in-out">
            <div className="flex w-full flex-col">{children}</div>
          </div>
        </div>
      </div>
    </NotificationsProvider>
  );
};
